<template>
    <div>
        <Field
            v-slot="{ field, errors, meta }"
            :name="errorLabel || name || label"
            :rules="rules"
            :model-value="inputValue"
        >
            <div>
                <span style="color: #757575">{{label}}</span> <span v-if="errors" class="error--text text-caption">{{errors[0]}}</span>
            </div>


            <v-autocomplete
                :model-value="inputValue"
                :items="items"
                :multiple="multiple"

                variant="outlined"
                density="compact"
                color="text"
                @update:model-value="update"
                @update:search="updateString"
                :item-title="itemText"
                :item-value="itemValue"
                :placeholder="placeholder"
                :no-data-text="noDataText"
                :closable-chips="deletableChips"
                :error-messages="errors && errors.length > 0 ? [''] : []"
                :disabled="disabled"
                :menu-props="{ zIndex: 2500 }"
            >
                <template #selection="{ item }">
                    {{item.raw.fullName}}
                </template>
            </v-autocomplete>


        </Field>
    </div>
<!--    <v-row>-->
<!--        <v-col cols="3" style="display: flex; align-items: center">-->
<!--            {{ label }}-->
<!--        </v-col>-->
<!--        <v-col cols="9">-->
<!--            <validation-provider-->
<!--                v-slot="{ errors }"-->
<!--                :name="errorLabel ? errorLabel : label"-->
<!--                :rules="rules"-->
<!--            >-->
<!--                <v-autocomplete-->
<!--                    :value="value"-->
<!--                    :items="items"-->
<!--                    :multiple="multiple"-->
<!--                    :chips="chips"-->
<!--                    outlined-->
<!--                    color="text"-->
<!--                    @input="update"-->
<!--                    @update:search-input="updateString"-->
<!--                    :item-text="itemText"-->
<!--                    :item-value="itemValue"-->
<!--                    :placeholder="placeholder"-->
<!--                    :no-data-text="noDataText"-->
<!--                    :deletable-chips="deletableChips"-->
<!--                    :error-messages="errors.length > 0 ? [''] : []"-->
<!--                ></v-autocomplete>-->
<!--                <div v-if="errors" class="error&#45;&#45;text text-caption">{{errors[0]}}</div>-->
<!--            </validation-provider>-->
<!--        </v-col>-->
<!--    </v-row>-->
</template>

<script>
import { Field, Form, defineRule, configure } from 'vee-validate'
import { required } from '@vee-validate/rules'

configure({
    validateOnInput: true,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnModelUpdate: true,
})

defineRule('required', required)

export default {
    components: {
        Field,
        Form
    },
    props: {
        value: {
            required: false,
            type: [Array, Number, String]
        },
        modelValue: {
            required: false,
        },
        label: {
            required: true,
            type: String
        },
        items: {
            required: true,
            type: Array
        },
        itemText: {
            type: String
        },
        itemValue: {
            type: String
        },
        multiple: {
            type: Boolean,
        },
        chips: {
            type: Boolean
        },
        placeholder: {
            type: String
        },
        noDataText: {
            type: String
        },
        deletableChips: {
            type: Boolean,
            default: true
        },
        rules: {

        },
        errorLabel: {
            type: String
        },
        disabled: {
            type: Boolean
        },
        name: {
            
        }
    },
    name: "AppAutocomplete",
    computed: {
        inputValue() {
            return this.modelValue !== undefined ? this.modelValue : this.value
        }
    },
    methods: {
        update(e) {
            this.$emit('input', e)
            this.$emit('update:modelValue', e)
        },
        updateString(e) {
            this.$emit('update-search-input', e)
        }
    }
}
</script>

<style scoped>

</style>